<template>
  <!-- The notices at the top of the screen that the cashier must act on, most urgent first: the
       device clock blocks every receipt; the certificate warns ahead of its expiry. A new notice
       of this kind is one more banner here, on AlertBanner. -->
  <device-time-banner />
  <certificate-expiry-banner />
</template>

<script setup lang="ts">
import DeviceTimeBanner from './DeviceTimeBanner.vue';
import CertificateExpiryBanner from './CertificateExpiryBanner.vue';
</script>
